import { render } from "./FormButton.vue?vue&type=template&id=0b6711d0"
import script from "./FormButton.vue?vue&type=script&lang=js"
export * from "./FormButton.vue?vue&type=script&lang=js"
script.render = render

export default script